import { Stack, styled, Typography } from '@mui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';

import useFormat from '../../../../hooks/useFormat';
import useWidgetLogoSize from '../../../hooks/useWidgetLogoSize';

const StyledTypography = styled(Typography)(() => ({
	overflow: 'hidden',
	textOverflow: 'ellipsis',

	'&.isMobileFormat': {
		display: '-webkit-box',
		WebkitLineClamp: '2',
		WebkitBoxOrient: 'vertical',
		wordBreak: 'break-word',
	},

	'&:not(.isMobileFormat)': {
		whiteSpace: 'nowrap',
	},
}));

const ImageContainer = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'bgColor' && prop !== 'logoSize',
})<{ bgColor: string; logoSize: number }>(({ bgColor, logoSize, theme: { shape } }) => ({
	justifyContent: 'center',
	alignItems: 'center',
	position: 'relative',
	width: logoSize,
	height: logoSize,
	borderRadius: shape.borderRadius * 2,
	overflow: 'hidden',

	'&::after': {
		content: '""',
		position: 'absolute',
		inset: 0,
		backgroundColor: bgColor,
		opacity: 0.3,
	},

	'&.isMobileFormat': {
		borderRadius: shape.borderRadius,
	},
}));

type SimulatorCardCardProps = {
	name: string;
	image: ReactNode;
	backgroundColor: string;
};

const SimulatorCard = ({ name, image, backgroundColor }: SimulatorCardCardProps) => {
	const { logoSize } = useWidgetLogoSize();
	const { isMobileFormat } = useFormat();

	return (
		<Stack padding={1} gap={1} alignItems="center">
			<ImageContainer className={clsx({ isMobileFormat })} bgColor={backgroundColor} logoSize={logoSize}>
				{image}
			</ImageContainer>

			<StyledTypography className={clsx({ isMobileFormat })} align="center" width="100%">
				{name}
			</StyledTypography>
		</Stack>
	);
};

export default SimulatorCard;
